module.exports = __webpack_public_path__ + "media/images/athletes/1785-04176a8814b3b6a4f8769070e16800be.png";